// AI Setting Modal Component
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { setAiSettingCurrent, setAiSettingSaving, setAiSettingError, addAiSetting, updateAiSetting } from '../../actions';
import { fetchAiSetting, createAiSetting, updateAiSetting as updateAiSettingApi, getDefaultAiSetting } from '../../api/ai_settingApi';
import './ai-setting-modal.css';
/**
 * AI設定モーダルコンポーネント
 */
const AiSettingModal = ({ isOpen, mode, settingId, settingData, onClose, onSaveSuccess, _saving, _error, dispatch }) => {
    const [formData, setFormData] = useState(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (isOpen) {
            if (mode === 'create') {
                const defaultSetting = getDefaultAiSetting();
                setFormData(defaultSetting);
            }
            else if (mode === 'edit' && settingData) {
                setFormData({ ...settingData });
            }
            else if (mode === 'view' && settingId) {
                loadSetting(settingId);
            }
            else if (mode === 'view' && settingData) {
                setFormData(settingData);
            }
        }
    }, [isOpen, mode, settingId, settingData]);
    const loadSetting = async (id) => {
        setLoading(true);
        dispatch(setAiSettingError(null));
        try {
            const setting = await fetchAiSetting(id);
            setFormData(setting);
            dispatch(setAiSettingCurrent(setting));
        }
        catch (error) {
            dispatch(setAiSettingError('設定の読み込みに失敗しました'));
        }
        finally {
            setLoading(false);
        }
    };
    const handleSaveSetting = async () => {
        if (!formData || !formData.ai_name.trim()) {
            dispatch(setAiSettingError('AI名は必須です'));
            return;
        }
        dispatch(setAiSettingSaving(true));
        dispatch(setAiSettingError(null));
        try {
            if (mode === 'edit' && formData.id) {
                // 更新
                const updatedSetting = await updateAiSettingApi(formData.id, formData);
                dispatch(updateAiSetting(updatedSetting));
            }
            else {
                // 新規作成
                const newSetting = await createAiSetting(formData);
                dispatch(addAiSetting(newSetting));
            }
            onSaveSuccess?.();
            onClose();
        }
        catch (error) {
            dispatch(setAiSettingError('設定の保存に失敗しました'));
        }
    };
    const handleInputChange = (path, value) => {
        if (!formData)
            return;
        const updateNestedObject = (obj, pathArray, newValue) => {
            const newObj = { ...obj };
            if (pathArray.length === 1) {
                newObj[pathArray[0]] = newValue;
            }
            else {
                newObj[pathArray[0]] = updateNestedObject(obj[pathArray[0]] || {}, pathArray.slice(1), newValue);
            }
            return newObj;
        };
        const pathArray = path.split('.');
        const updatedFormData = updateNestedObject(formData, pathArray, value);
        setFormData(updatedFormData);
    };
    const handleArrayChange = (path, index, value) => {
        if (!formData)
            return;
        const pathArray = path.split('.');
        const currentArray = pathArray.reduce((obj, key) => obj && obj[key], formData);
        if (!Array.isArray(currentArray))
            return;
        const newArray = [...currentArray];
        newArray[index] = value;
        handleInputChange(path, newArray);
    };
    const addArrayItem = (path) => {
        if (!formData)
            return;
        const pathArray = path.split('.');
        const currentArray = pathArray.reduce((obj, key) => obj && obj[key], formData);
        if (!Array.isArray(currentArray))
            return;
        const newArray = [...currentArray, ''];
        handleInputChange(path, newArray);
    };
    const removeArrayItem = (path, index) => {
        if (!formData)
            return;
        const pathArray = path.split('.');
        const currentArray = pathArray.reduce((obj, key) => obj && obj[key], formData);
        if (!Array.isArray(currentArray))
            return;
        const newArray = currentArray.filter((_, i) => i !== index);
        handleInputChange(path, newArray);
    };
    if (!isOpen)
        return null;
    const getModalTitle = () => {
        switch (mode) {
            case 'create':
                return '🤖 AI対話設定 - 新規作成';
            case 'edit':
                return '🤖 AI対話設定 - 編集';
            case 'view':
                return '🤖 AI対話設定 - 詳細表示';
            default:
                return '🤖 AI対話設定';
        }
    };
    const isReadOnly = mode === 'view';
    if (loading || !formData) {
        return (React.createElement("div", { className: "ai-setting-modal-backdrop", onClick: onClose },
            React.createElement("div", { className: "ai-setting-modal", onClick: (e) => e.stopPropagation() },
                React.createElement("div", { className: "ai-setting-loading" },
                    React.createElement("div", { className: "ai-setting-spinner" }),
                    React.createElement("p", null, "\u8A2D\u5B9A\u3092\u8AAD\u307F\u8FBC\u307F\u4E2D...")))));
    }
    return (React.createElement("div", { className: "ai-setting-modal-backdrop", onClick: onClose },
        React.createElement("div", { className: "ai-setting-modal", onClick: (e) => e.stopPropagation() },
            React.createElement("div", { className: "ai-setting-modal-header" },
                React.createElement("h2", null, getModalTitle()),
                React.createElement("button", { onClick: onClose, className: "ai-setting-modal-close", "aria-label": "\u9589\u3058\u308B" }, "\u00D7")),
            _error && (React.createElement("div", { className: "ai-setting-error" },
                "\u274C ",
                _error)),
            React.createElement("div", { className: "ai-setting-modal-content" },
                React.createElement("div", { className: `ai-setting-form ${isReadOnly ? 'ai-setting-form--readonly' : ''}` },
                    React.createElement("div", { className: "ai-setting-section" },
                        React.createElement("h3", null, "\u57FA\u672C\u60C5\u5831"),
                        React.createElement("div", { className: "ai-setting-field" },
                            React.createElement("label", { htmlFor: "ai_name" }, "AI\u540D *"),
                            isReadOnly ? (React.createElement("div", { className: "ai-setting-value" }, formData.ai_name)) : (React.createElement("input", { id: "ai_name", type: "text", value: formData.ai_name, onChange: (e) => handleInputChange('ai_name', e.target.value), placeholder: "AI\u540D\u3092\u5165\u529B", required: true })))),
                    React.createElement("div", { className: "ai-setting-section" },
                        React.createElement("h3", null, "Jitsi\u8A2D\u5B9A"),
                        React.createElement("div", { className: "ai-setting-field" },
                            React.createElement("label", { htmlFor: "jitsi_domain" }, "\u30C9\u30E1\u30A4\u30F3"),
                            isReadOnly ? (React.createElement("div", { className: "ai-setting-value" }, formData.jitsi_config?.domain || 'N/A')) : (React.createElement("input", { id: "jitsi_domain", type: "text", value: formData.jitsi_config.domain, onChange: (e) => handleInputChange('jitsi_config.domain', e.target.value) }))),
                        React.createElement("div", { className: "ai-setting-field" },
                            React.createElement("label", { htmlFor: "jitsi_room_name" }, "\u30EB\u30FC\u30E0\u540D"),
                            isReadOnly ? (React.createElement("div", { className: "ai-setting-value" }, formData.jitsi_config?.room_name || 'N/A')) : (React.createElement("input", { id: "jitsi_room_name", type: "text", value: formData.jitsi_config.room_name, onChange: (e) => handleInputChange('jitsi_config.room_name', e.target.value) }))),
                        React.createElement("div", { className: "ai-setting-subsection" },
                            React.createElement("h4", null, "\u30C1\u30E3\u30C3\u30C8\u30DC\u30C3\u30C8\u8A2D\u5B9A"),
                            React.createElement("div", { className: "ai-setting-checkbox" }, isReadOnly ? (React.createElement("div", { className: "ai-setting-field" },
                                React.createElement("label", null, "\u72B6\u614B"),
                                React.createElement("div", { className: `ai-setting-status ${formData.jitsi_config?.chatbot?.activate ? 'active' : 'inactive'}` }, formData.jitsi_config?.chatbot?.activate ? '有効' : '無効'))) : (React.createElement("label", null,
                                React.createElement("input", { type: "checkbox", checked: formData.jitsi_config.chatbot.activate, onChange: (e) => handleInputChange('jitsi_config.chatbot.activate', e.target.checked) }),
                                "\u30C1\u30E3\u30C3\u30C8\u30DC\u30C3\u30C8\u3092\u6709\u52B9\u306B\u3059\u308B")))),
                        React.createElement("div", { className: "ai-setting-subsection" },
                            React.createElement("h4", null, "\u30D3\u30C7\u30AA\u30DC\u30C3\u30C8\u8A2D\u5B9A"),
                            React.createElement("div", { className: "ai-setting-checkbox" }, isReadOnly ? (React.createElement("div", { className: "ai-setting-field" },
                                React.createElement("label", null, "\u72B6\u614B"),
                                React.createElement("div", { className: `ai-setting-status ${formData.jitsi_config?.videobot?.activate ? 'active' : 'inactive'}` }, formData.jitsi_config?.videobot?.activate ? '有効' : '無効'))) : (React.createElement("label", null,
                                React.createElement("input", { type: "checkbox", checked: formData.jitsi_config.videobot.activate, onChange: (e) => handleInputChange('jitsi_config.videobot.activate', e.target.checked) }),
                                "\u30D3\u30C7\u30AA\u30DC\u30C3\u30C8\u3092\u6709\u52B9\u306B\u3059\u308B"))),
                            !isReadOnly && (React.createElement("div", { className: "ai-setting-field" },
                                React.createElement("label", null, "AI\u540D\u524D\u5019\u88DC"),
                                formData.jitsi_config.videobot.client.myname.map((name, index) => (React.createElement("div", { key: index, className: "ai-setting-array-item" },
                                    React.createElement("input", { type: "text", value: name, onChange: (e) => handleArrayChange('jitsi_config.videobot.client.myname', index, e.target.value) }),
                                    React.createElement("button", { type: "button", onClick: () => removeArrayItem('jitsi_config.videobot.client.myname', index), className: "ai-setting-button ai-setting-button--remove" }, "\uD83D\uDDD1\uFE0F \u524A\u9664")))),
                                React.createElement("button", { type: "button", onClick: () => addArrayItem('jitsi_config.videobot.client.myname'), className: "ai-setting-button ai-setting-button--add" }, "\u2795 \u8FFD\u52A0"))))),
                    React.createElement("div", { className: "ai-setting-section" },
                        React.createElement("h3", null, "\u30C1\u30E3\u30C3\u30C8\u8A2D\u5B9A"),
                        React.createElement("div", { className: "ai-setting-field" },
                            React.createElement("label", { htmlFor: "chatgpt_model" }, "ChatGPT\u30E2\u30C7\u30EB"),
                            isReadOnly ? (React.createElement("div", { className: "ai-setting-value" }, formData.chat_config?.response?.chatgpt_model_name || 'N/A')) : (React.createElement("select", { id: "chatgpt_model", value: formData.chat_config.response.chatgpt_model_name, onChange: (e) => handleInputChange('chat_config.response.chatgpt_model_name', e.target.value) },
                                React.createElement("option", { value: "gpt-4o" }, "GPT-4o"),
                                React.createElement("option", { value: "gpt-4.1" }, "GPT-4.1"),
                                React.createElement("option", { value: "gpt-3.5-turbo" }, "GPT-3.5-turbo"))))))),
            React.createElement("div", { className: "ai-setting-modal-footer" }, mode === 'view' ? (React.createElement(React.Fragment, null,
                React.createElement("button", { onClick: onClose, className: "ai-setting-button ai-setting-button--cancel" }, "\uD83D\uDC41\uFE0F \u9589\u3058\u308B"))) : (React.createElement(React.Fragment, null,
                React.createElement("button", { onClick: onClose, className: "ai-setting-button ai-setting-button--cancel", disabled: _saving }, "\u2715 \u30AD\u30E3\u30F3\u30BB\u30EB"),
                React.createElement("button", { onClick: handleSaveSetting, className: "ai-setting-button ai-setting-button--primary", disabled: _saving }, _saving ? '⏳ 保存中...' : '💾 保存')))))));
};
/**
 * Redux stateをpropsにマッピング
 */
function mapStateToProps(state) {
    const aiSettingState = state['features/ai_setting'];
    return {
        _saving: aiSettingState.saving,
        _error: aiSettingState.error
    };
}
export default translate(connect(mapStateToProps)(AiSettingModal));
